import type { Me } from '../api/types'
import { db } from './db'

export const metaKeys = {
  me: 'me',
  lastSyncAt: 'lastSyncAt',
  pushSubscribed: 'pushSubscribed',
  iosHintDismissed: 'iosHintDismissed',
  /** When the person last said "Not now" to turning notifications on (epoch ms). */
  pushPromptSnoozedAt: 'pushPromptSnoozedAt',
  /** In the app: this install's FCM token, as last sent to the server (so signing out can remove it). */
  nativePushToken: 'nativePushToken',
  draft: (channelId: string) => `draft:${channelId}`,
} as const

export interface Draft {
  body: string
  replyToId: string | null
}

export async function getMeta<T>(key: string): Promise<T | undefined> {
  const row = await db.meta.get(key)
  return row?.value as T | undefined
}

export async function setMeta(key: string, value: unknown): Promise<void> {
  await db.meta.put({ key, value })
}

export async function deleteMeta(key: string): Promise<void> {
  await db.meta.delete(key)
}

export const getCachedMe = () => getMeta<Me>(metaKeys.me)
export const setCachedMe = (me: Me) => setMeta(metaKeys.me, me)

export async function saveDraft(channelId: string, draft: Draft): Promise<void> {
  if (!draft.body && !draft.replyToId) await deleteMeta(metaKeys.draft(channelId))
  else await setMeta(metaKeys.draft(channelId), draft)
}

export const loadDraft = (channelId: string) => getMeta<Draft>(metaKeys.draft(channelId))
